import { useTranslation } from 'react-i18next';

import { usePageTitle } from '@/features/pageTitle';
import { PageContainer } from '@/shared/ui/PageContainer';
import { PlaceholderPage } from '@/shared/ui/PlaceholderPage';

export const TemplatesPage = () => {
  const { t } = useTranslation();

  usePageTitle(t('common:menu.templates'));

  return (
    <PageContainer>
      <PlaceholderPage />
    </PageContainer>
  );
};
